<template>
  <div class="wrapper">
    <el-button
      v-if="!value"
      @click="initForm"
      class="fluid fill-link-button"
      type="primary"
    >
      Uzupełnij pokrewne kategorie
    </el-button>
    <div v-else>
      <div class="inline-form-group">
        <el-form-item
          label="Tytuł lewej kolumny"
          :error="getErrors(errors, 'left_title')"
        >
          <el-input v-model="value.left_title" />
        </el-form-item>
        <el-button
          @click="removeElement"
          v-if="nullable"
          type="warning"
          class="remove-button"
          size="mini"
        >
          Usuń pokrewne kategorie
        </el-button>
      </div>
      <el-form-item
        label="Tytuł prawej kolumny"
        :error="getErrors(errors, 'right_title')"
      >
        <el-input v-model="value.right_title" />
      </el-form-item>
      <el-form-item label="Linki lewej kolumny">
        <component-compiler :content="getLinksFormset('left_links')" />
      </el-form-item>
      <el-form-item label="Linki prawej kolumny">
        <component-compiler :content="getLinksFormset('right_links')" />
      </el-form-item>
    </div>
    <div class="el-form-item__error" v-if="typeof errors === 'string'">
      {{ errors }}
    </div>
  </div>
</template>
<script>
import WYSIWYGInput from '@/components/inputs/WYSIWYGInput'
import LinkInput from '@/components/inputs/ForeignKeys/LinkInput'
import fields from '@/components/fields/'
import ComponentCompiler from '@/components/ComponentCompiler'
import { get } from 'lodash'

export default {
  components: {
    WYSIWYGInput,
    LinkInput,
    ComponentCompiler
  },
  props: {
    value: { type: Object, required: false },
    errors: {
      type: [Object, String, Function],
      default: () => {}
    },
    nullable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    initForm() {
      this.$emit('input', { title: '' })
    },
    removeElement() {
      this.$emit('input', null)
    },
    getLinksFormset(field) {
      if (this.value[field] === undefined) {
        this.$set(this.value, field, [])
      }
      return new fields.Formset({
        modelPath: [this, 'value', field],
        items: this.value[field].map((item, i) => {
          return {
            headerLabel: get(item, ['label']),
            fields: [
              new fields.Link({
                label: 'Link',
                errors:
                  this.errors && this.errors[field]
                    ? this.errors[field][i]
                    : null,
                modelPath: [this, 'value', field, i]
              })
            ]
          }
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.widget-info {
  padding: 9px;
}

.remove-button {
  display: inline-block;
  margin: 0 0 22px 11px;
}

.fluid {
  width: 100%;
}

.wrapper {
  background: #f7f7f7;
  padding: 22px;
  border: 1px solid #e2e2e2;
  position: relative;
  margin-bottom: 22px;
}

.fill-link-button {
  margin-bottom: 22px;
}
</style>
